import type { Order } from '../store/useStore'

/**
 * #1214 客・厨房・レシートで共通に見せる注文番号。
 *
 * 採番済みの呼び出し番号 (`callNumber`, 例 `A-01`) を最優先。無い注文
 * (#1214 以前の既存データ) は従来の doc id 先頭6文字にフォールバックする。
 *
 * サーバ側の対応実装: `services/pay/api/domains/shop/domain/printing/models.py`
 * `display_order_number()` — 両者で同じ値になることがレシート/伝票/画面の
 * 番号一致を担保する。
 */
export function displayOrderNumber(order: Pick<Order, 'id'> & { callNumber?: string }): string {
  const call = (order.callNumber || '').trim()
  if (call) return call
  return (order.id || '').slice(0, 6).toUpperCase()
}
